import type { MenuItem } from '../types';

interface ItemCardProps {
  item: MenuItem;
  onSelect: (item: MenuItem) => void;
}

export function ItemCard({ item, onSelect }: ItemCardProps) {
  return (
    <button type="button" className="hc-item-card" onClick={() => onSelect(item)}>
      {item.img_url && (
        <img className="hc-item-img" src={item.img_url} alt={item.name} loading="lazy" />
      )}
      <div className="hc-item-info">
        <h3 className="hc-item-name">{item.name}</h3>
        {item.description && (
          <p className="hc-item-desc">{item.description}</p>
        )}
      </div>
      <span className="hc-item-price">{Number(item.price).toFixed(2)} &euro;</span>
    </button>
  );
}
